export enum MeasurementPropagationBehavior {
    NONE = "NONE",
    COPY = "COPY"
}
